<template>
  <v-menu v-model="menu" offset-y :close-on-content-click="false">
    <template #activator="{ on: onMenu }">
      <v-tooltip bottom>
        <template #activator="{ on: onTooltip }">
          <v-icon
            v-on="{ ...onMenu, ...onTooltip }"
            v-text="'mdi-content-save'"
          />
        </template>
        <span>Сохранить фильтр</span>
      </v-tooltip>
    </template>

    <v-card width="370px">
      <div class="font-18 px-3 py-2">Сохранение фильтра</div>
      <v-divider />
      <v-card-text class="pb-0">
        <validation-observer ref="validator">
          <validation-provider
            v-slot="{ errors }"
            rules="required|max:50"
            name="Название фильтра"
          >
            <v-text-field
              v-model="name"
              dense
              outlined
              label="Название фильтра"
              maxlength="50"
              :error-messages="errors"
            />
          </validation-provider>
        </validation-observer>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn small color="primary" depressed @click="saveFilter">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      name: null
    };
  },
  methods: {
    async saveFilter() {
      const { validator } = this.$refs;
      if (!validator) return;
      if (!(await validator.validate())) return;
      this.$emit("save", this.name);
      this.name = null;
      this.menu = false;
      validator.reset();
    }
  }
};
</script>
